// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","993":"analises"}[chunkId] + "-legacy." + {"443":"18ee0eca","993":"9858866c"}[chunkId] + ".js";
};